import { IS_ANDROID, IS_APP, IS_IOS, IS_RN } from '../constants';
import AndroidNative from './native.android';
import IOSNative from './native.ios';
import RNNative from './native.rn';
import WebNative from './native.web';
var Native = /** @class */ (function () {
    function Native() {
        if (IS_RN) {
            this.platformNative = new RNNative();
        }
        else if (IS_APP) {
            if (IS_IOS)
                this.platformNative = new IOSNative();
            else if (IS_ANDROID)
                this.platformNative = new AndroidNative();
            else
                this.platformNative = new WebNative();
        }
        else {
            this.platformNative = new WebNative();
        }
    }
    Object.defineProperty(Native.prototype, "callbackIdMap", {
        get: function () {
            return this.platformNative.callbackIdMap;
        },
        enumerable: false,
        configurable: true
    });
    Native.prototype.postMessage = function (target, method, params, callback) {
        this.platformNative.postMessage(target, method, params, callback);
    };
    Native.prototype.setCallback = function (callback, callbackId) {
        return this.platformNative.setCallback(callback, callbackId);
    };
    return Native;
}());
export var native = new Native();
